import { useQuery } from '@tanstack/react-query';

import { CvSearchSyncStatusResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';

const SYNC_STATUS_REFETCH_INTERVAL = 5 * 60 * 1000;

interface Return {
  isLoading: boolean;
  syncStatus: CvSearchSyncStatusResponseDto | undefined;
}

export const useGetCvSearchSyncStatus = (enabled: boolean): Return => {
  const { cvSearchSyncStatusApi } = useApiClient();

  const { data, isPending } = useQuery<CvSearchSyncStatusResponseDto>({
    enabled,
    queryFn: async () => (await cvSearchSyncStatusApi.getCvSearchSyncStatus()).data,
    queryKey: [QueryKeyEnum.CV_SEARCH.SYNC_STATUS],
    refetchInterval: SYNC_STATUS_REFETCH_INTERVAL,
  });

  return { isLoading: enabled && isPending, syncStatus: data };
};
